export const EC_GQL_ID = 'ec';
